export default __webpack_public_path__ + "static/media/fontLato400_01.361f3dbb.woff2";